import { z } from 'zod';
import { STAFF_CONNECTION_METHOD_VALUES } from './agent-voice-settings-constants.js';
/** What a new transfer action starts with in the form. The author can clear
 *  it; at call time a blank message means the agent says nothing. */
export const DEFAULT_TRANSFER_MESSAGE = 'One moment while I connect you with a member of our team.';
// One entry per PHONE_CALL row, in dial order.
export const RecipientEntrySchema = z.object({
    number: z.string().min(1),
    extension: z.string().optional(),
    sourceRoleMemberId: z.string().nullable(),
    staffId: z.string().optional(),
});
export const TransferActionParametersSchema = z.object({
    connectionMethod: z.enum(STAFF_CONNECTION_METHOD_VALUES),
    preserveOriginalCallerId: z.boolean().optional(),
    declinedMessage: z.string().nullable(),
    // Line the agent says to the caller before it dials. Null says nothing.
    transferMessage: z.string().nullable().default(null),
    // Older rows carry the agent's instructions here. No form writes it and no
    // call reads it; the graph's edges carry what the agent does next.
    transferInstructions: z.string().nullable().optional(),
    recipients: z.array(RecipientEntrySchema),
    // Voicemail behavior on the briefing dial. Shape kept in step with
    // VoicemailSettingsSchema (the shared contract the start-call node will
    // reuse); inlined here because zod's `.merge()` degrades inference for
    // every consumer of the merged type.
    voicemailDetectionEnabled: z.boolean().default(true),
    leaveVoicemailEnabled: z.boolean().default(true),
    voicemailMessage: z.string().nullable().default(null),
});
/** AI_TRANSFER dials from the trunk's own caller ID; preserving the
 *  original caller ID gets rejected by Twilio with SIP 403. Drop the key
 *  on save so it never reaches storage. */
export function stripIncompatibleCallerIdPreservation(params) {
    if (params.connectionMethod !== 'AI_TRANSFER')
        return params;
    const { preserveOriginalCallerId: _, ...rest } = params;
    return rest;
}
export function parseTransferActionParameters(action) {
    if (action?.actionType !== 'TRANSFER')
        return null;
    const parsed = TransferActionParametersSchema.safeParse(action.parameters);
    return parsed.success ? parsed.data : null;
}
export function transferPhoneRows(parameters) {
    return parameters.recipients.map(recipient => ({
        // Rows keep the extension in the number, where dial-out reads it.
        parameters: {
            number: recipient.extension
                ? `${recipient.number}#${recipient.extension}`
                : recipient.number,
            email: null,
        },
        sourceRoleMemberId: recipient.sourceRoleMemberId,
    }));
}
//# sourceMappingURL=transfer-action.js.map